export default __webpack_public_path__ + "support-icon.978970524bd91d9c62a3bdbb62e1f895.svg";